const PASTOR_FIELDS = [
  { key: 'name', label: 'お名前', maxLength: 120, required: true, autoComplete: 'name' },
  { key: 'church', label: '所属教会', maxLength: 200, required: true, autoComplete: 'organization' },
  { key: 'faithCategory', label: '信仰分類', maxLength: 120, required: true, placeholder: 'プロテスタント、カトリックなど' },
  { key: 'region', label: '対応地域', maxLength: 200, required: true, placeholder: '埼玉県川口市・オンラインなど' },
  { key: 'email', label: '公開メールアドレス', maxLength: 254, required: true, type: 'email', autoComplete: 'email' },
  { key: 'phone', label: '公開電話番号', maxLength: 40, type: 'tel', autoComplete: 'tel' },
  { key: 'phoneHours', label: '対応可能な曜日・時間', maxLength: 200, placeholder: '平日10:00〜17:00など' },
  { key: 'contactUrl', label: '教会・プロフィールURL', maxLength: 1000, type: 'url', placeholder: 'https://' },
  { key: 'message', label: '対応できる相談・補足', maxLength: 2000, multiline: true },
];

function preparePastorRegistration(input) {
  if (!input || typeof input !== 'object' || Array.isArray(input)) throw Error('入力内容を確認してください。');
  const fields = {};
  for (const field of PASTOR_FIELDS) {
    const value = input[field.key] ?? '';
    if (typeof value !== 'string' || value.length > field.maxLength) throw Error(`${field.label}の入力内容・文字数を確認してください。`);
    fields[field.key] = value.trim();
    if (field.required && !fields[field.key]) throw Error(`${field.label}を入力してください。`);
    if (!field.multiline && /[\r\n]/.test(fields[field.key])) throw Error(`${field.label}に改行は使用できません。`);
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) throw Error('メールアドレスを確認してください。');
  if (fields.phone && (!/^\+?[0-9 ()-]+$/.test(fields.phone) || fields.phone.replace(/\D/g, '').length < 7)) throw Error('電話番号は半角数字で入力してください。');
  if (fields.contactUrl) {
    let url;
    try { url = new URL(fields.contactUrl); } catch { throw Error('URLを確認してください。'); }
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) throw Error('URLはhttp://またはhttps://で入力してください。');
  }
  if (input.consent !== true) throw Error('SOS対応と掲載への同意を確認してください。');
  fields.consent = true;
  return {
    fields,
    subject: 'ASMRキリスト教会 SOS対応牧師 登録申請',
    text: [
      'SOS対応牧師の登録申請が届きました。内容を確認し、牧師一覧へ掲載してください。',
      '',
      ...PASTOR_FIELDS.map(field => `${field.label}：${fields[field.key] || '未記入'}`),
      '',
      '一般の方からのSOS対応が可能であり、本人による申請・連絡先等の一覧掲載・登録確認のための連絡に同意済み。',
    ].join('\n'),
  };
}

module.exports = { PASTOR_FIELDS, preparePastorRegistration };
